import React, { useMemo } from "react";
import {
  FieldCategoryTypeEnum,
  ITicketTypes,
  TicketField,
} from "../../../TeamSettings/container/Projects/container/WorkItems/types";
import TicketCustomFields from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField";
import {
  ICustomFieldsTicketForm,
  ITicketFormData,
} from "../../containers/Tickets/types";
import { findFieldGroupByCategory } from "../../helpers";

interface Props {
  form: ITicketFormData;
  onChange: (data: ICustomFieldsTicketForm) => void;
  ticketTypes: ITicketTypes[]
}
const CustomFields: React.FC<Props> = ({ form, onChange,ticketTypes }) => {

  const selectedType = useMemo(
    () => ticketTypes.find((t) => t._id === form.type),
    [ticketTypes, form.type],
  );
  
  const customFields = useMemo(
    () =>
      findFieldGroupByCategory(
        selectedType?.ticketTypeFields || [],
        FieldCategoryTypeEnum.CUSTOM_FIELDS,
      ),
    [selectedType],
  );

  

  return (
    <div className="flex flex-col gap-[4px] w-full">
      <TicketCustomFields
        customFields={customFields as TicketField[]}
        form={form}
        onChange={onChange}
      />
    </div>
  );
};

export default CustomFields;
